/**
 * FooterConfigBlock Edit component.
 * Shows a summary preview in the canvas and exposes full config in the sidebar.
 */

import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import InlineForm from '@plone/volto/components/manage/Form/InlineForm';
import FooterConfigSchema from './schema';

/**
 * Canvas preview shown while editing.
 * Deliberately lightweight — the real work happens in the sidebar.
 */
const FooterConfigEdit = (props) => {
  const { data, selected, onChangeBlock, block } = props;

  const columnCount = data.columns?.length || 0;
  const linkCount =
    data.columns?.reduce((acc, col) => acc + (col.links?.length || 0), 0) || 0;
  const socialCount = data.social?.length || 0;
  const footerBarCount = data.footerBarLinks?.length || 0;

  return (
    <>
      {/* Canvas placeholder */}
      <div className="footer-config-block-edit">
        <div className="footer-config-block-edit__header">
          <i className="bi bi-layout-text-sidebar" />
          <span>Footer Configuration</span>
        </div>
        <div className="footer-config-block-edit__summary">
          <div className="footer-config-block-edit__stat">
            <strong>{columnCount}</strong>
            <span>{columnCount === 1 ? 'column' : 'columns'}</span>
          </div>
          <div className="footer-config-block-edit__stat">
            <strong>{linkCount}</strong>
            <span>{linkCount === 1 ? 'link' : 'links'}</span>
          </div>
          <div className="footer-config-block-edit__stat">
            <strong>{socialCount}</strong>
            <span>social</span>
          </div>
          <div className="footer-config-block-edit__stat">
            <strong>{footerBarCount}</strong>
            <span>footer bar</span>
          </div>
        </div>
        <p className="footer-config-block-edit__hint">
          Use the sidebar panel to manage columns, links, social accounts, and
          copyright details.
        </p>
      </div>

      {/* Sidebar */}
      <SidebarPortal selected={selected}>
        <InlineForm
          schema={FooterConfigSchema}
          title={FooterConfigSchema.title}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          formData={data}
        />
      </SidebarPortal>
    </>
  );
};

export default FooterConfigEdit;
